import { AppState, Action } from './AppProvider'

export const appStateReducer = (state: AppState, action: Action): AppState => {
  switch (action.type) {
    case 'SET_FILTERS':
      return { ...state, filters: action.payload }
    case 'SET_DASHBOARD_DATA':
      return {
        ...state,
        dashboardData: action.payload.data,
        dashboardFilters: action.payload.filters,
        dashboardLoading: false,
      }
    case 'SET_DASHBOARD_LOADING':
      return { ...state, dashboardLoading: action.payload }
    case 'SET_PERFORMANCE_DATA':
      return { ...state, performanceData: action.payload.data, performanceFilters: action.payload.filters }
    case 'SET_KR_DATA':
      return {
        ...state,
        krData: action.payload.data,
        krEnvironment: action.payload.environment,
        krFetchedAt: action.payload.fetchedAt,
      }
    case 'SET_PLANS':
      return { ...state, plans: action.payload }
    case 'SET_USERS':
      return { ...state, users: action.payload }
    case 'SET_ERROR':
      return { ...state, error: action.payload, dashboardLoading: false }
    case 'SET_FEEDBACK_DATA':
      return {
        ...state,
        feedbackData: action.payload.items,
        feedbackFilters: action.payload.filters,
        feedbackType: action.payload.feedbackType,
      }
    case 'SET_CONVERSATIONS_DATA':
      return {
        ...state,
        conversationsData: action.payload.items,
        conversationsFilters: action.payload.filters,
      }
    case 'SET_LLM_DATA':
      return {
        ...state,
        llmData: action.payload.data,
        llmStartDate: action.payload.startDate,
        llmEndDate: action.payload.endDate,
      }
    default:
      return state
  }
}
